<template>
  <!-- Alert Logout Modal -->
  <div
    class="modal fade done"
    id="alertModal"
    aria-hidden="true"
    aria-labelledby="exampleModalToggleLabel2"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <button
          type="button"
          class="close-model-btn"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <i class="fa-regular fa-circle-xmark"></i>
        </button>

        <div class="content-model-me">
          <div class="modal-header">
            <h2 class="section-title">هل تود بالفعل تسجيل الخروج؟</h2>
          </div>

<div class="modal-body">
              <div class="logout-anim-wrap" aria-hidden="true">
                <div class="logout-ring ring-one"></div>
                <div class="logout-ring ring-two"></div>
                <div class="logout-core">
                  <div class="exit-scene">
                    <span class="exit-door-frame">
                      <span class="exit-door-panel"></span>
                    </span>
                    <i class="fa-solid fa-person-walking exit-person"></i>
                    <i class="fa-solid fa-arrow-right-from-bracket exit-arrow"></i>
                  </div>
                </div>
              </div>
            </div>

          <div class="modal-footer">
            <button
              class="main-btn red md up"
              :disabled="disabled"
              type="button"
              @click.prevent="signOut()"
            >
              نعم
               <div class="spinner-border" role="status" v-if="disabled">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </button>
            <button
              class="main-btn md up"
              type="submit"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              لا
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--logout modal-->
</template>

<script>
import { defineComponent } from "vue";
import axios from 'axios'
import { fullLogoutWipe } from "../../utils/defaults";

export default defineComponent({
  name: "removeAccountModal",
  data() {
    return {
        disabled : false
    };
  },
  methods: {
    async signOut(){
      const fd = new FormData();
      this.disabled = true;
      let ok = false;
      try {
        const res = await axios.post('sign-out', fd, {
          headers: { 'Authorization':  `Bearer ${sessionStorage.getItem('token')}` }
        });
        ok = (res && res.data && res.data.key === 'success');
      } catch (e) {
        ok = false;
      } finally {
        fullLogoutWipe(axios);

        try {
          document.querySelectorAll('.modal-backdrop').forEach(el => { el.classList.remove('show'); el.style.display = 'none'; });
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.paddingRight = '';
          const alertModal = document.getElementById('alertModal');
          if (alertModal) { alertModal.classList.remove('show'); alertModal.style.display = 'none'; alertModal.setAttribute('aria-hidden','true'); }
          const app = document.getElementById('app');
          if (app && app.hasAttribute('aria-hidden')) app.removeAttribute('aria-hidden');
        } catch (_) { void 0; }

        if (this.$swal) {
          this.$swal({ icon: ok ? 'success' : 'info', title: 'تم تسجيل الخروج', timer: 1200, showConfirmButton: false });
        }

        setTimeout(() => {
          this.$router.push('/').catch(()=>{});
          location.reload();
        }, 900);

        this.disabled = false;
      }
    }
  },

  components: {},
});
</script>
<style scoped>
.logout-anim-wrap {
  position: relative;
  width: 160px;
  height: 160px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logout-ring {
  position: absolute;
  inset: 0;
  border-radius: 18px;
  border: 2px solid rgba(59, 130, 246, 0.18);
  background: rgba(219, 234, 254, 0.92);
  animation: logoutPulse 2.3s ease-out infinite;
}

.ring-two {
  animation-delay: 0.85s;
}

.logout-core {
  position: relative;
  width: 98px;
  height: 98px;
  border-radius: 16px;
  background: rgb(77, 170, 221);
  box-shadow: 0 16px 34px rgba(77, 170, 221, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.exit-scene {
  position: relative;
  width: 62px;
  height: 58px;
}

.exit-door-frame {
  position: absolute;
  top: 6px;
  bottom: 6px;
  right: 0;
  left: 8px;
  border: 2px solid rgba(255, 255, 255, 0.9);
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.1);
  perspective: 220px;
}

.exit-door-panel {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 50%;
  border-left: 1px solid rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.4);
  transform-origin: right center;
  animation: exitOpenDoor 2.3s ease-in-out infinite;
}

.exit-door-panel::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
  transform: translateY(-50%);
}

.exit-person {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: #fff;
  font-size: 26px;
  z-index: 2;
  animation: exitWalk 2.3s ease-in-out infinite;
}

.exit-arrow {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  color: #fff;
  font-size: 16px;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.55);
  opacity: 0;
  z-index: 3;
  animation: exitArrow 2.3s ease-in-out infinite;
}

@keyframes exitOpenDoor {
  0%, 22% {
    transform: rotateY(0deg);
  }
  55%, 100% {
    transform: rotateY(-72deg);
  }
}

@keyframes exitWalk {
  0%, 25% {
    transform: translateY(-50%) translateX(0);
    opacity: 1;
  }
  55% {
    transform: translateY(-50%) translateX(4px);
    opacity: 1;
  }
  82%, 100% {
    transform: translateY(-50%) translateX(34px);
    opacity: 0.1;
  }
}

@keyframes exitArrow {
  0%, 25% {
    opacity: 0;
    transform: translateY(-50%) translateX(4px);
  }
  45%, 100% {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}

@keyframes logoutPulse {
  0% {
    transform: scale(0.74);
    opacity: 0.78;
  }
  70% {
    transform: scale(1.18);
    opacity: 0;
  }
  100% {
    transform: scale(1.18);
    opacity: 0;
  }
}
</style>
